import { useRef } from "preact/hooks"
import { createHashHistory } from "history"
import Router from "preact-router"
import { CometChat } from "./components/CometChat"
import { ClueModal, TriviaModal } from "./components/Modals"
import { Navbar } from "./components/Navbar"
import popups from "./popups"
import { networkRoutes, serviceURL } from "./rooms/network"
import { homeLinks, sessions } from "./rooms/sessions"
import { availableTimes } from "./rooms/callInfo"
import { Room } from "./components/Room"
import { DisplayOnce, ElfsightPopup, Modal } from "src/utils/fw"
import { handleNewRoute } from "src/utils/routing"

export default function Main() {

    const triviaRef = useRef(null)

    const links = [
        {
            background: "https://assets.swoogo.com/uploads/full/1649002-6230b671155da.jpg",
            default: true,
            links: [
                {
                    width: "13.8%",
                    height: "25.1%",
                    left: "23.4%",
                    top: "46.8%",
                    label: "Activity Lounge",
                    href: "/activity-lounge",
                    isExternal: true,
                },
                {
                    width: "18.4%",
                    height: "26.1%",
                    left: "49.4%",
                    top: "43.8%",
                    label: "Main Stage",
                    href: "/main-stage",
                    isExternal: true,
                },
                {
                    width: "10.8%",
                    height: "23.1%",
                    left: "80.4%",
                    top: "52.8%",
                    label: "Sessions",
                    href: "/sessions",
                    isExternal: true,
                },
                {
                    width: "8.8%",
                    height: "14.1%",
                    left: "45.4%",
                    top: "17.8%",
                    label: "Gallery",
                    href: "/gallery",
                    isExternal: true,
                },
                {
                    width: "8.8%",
                    height: "14.1%",
                    left: "55.4%",
                    top: "17.8%",
                    label: "Networking Café",
                    href: "/networking-cafe",
                    isExternal: true,
                },
                {
                    width: "15.4%",
                    height: "16.2%",
                    left: "68.8%",
                    top: "77.4%",
                    onClick: () => { document.getElementById("lobby-clue").click() },
                    label: "Break the Bias"
                }
            ],
            name: "lobby",
            // extras: <DisplayOnce
            // 	id="lobby-postevent"
            // 	// This should be in the event CSS tbh but I couldn't be arsed
            // 	style={{
            // 		padding: "3rem",
            // 		background: "#862c91",
            // 		borderRadius: "1rem",
            // 		color: "white",
            // 		maxWidth: "60rem",
            // 	}}
            // 	dismissHTML="X"
            // >
            // 	<h1>2022 International Women’s Day Summit by Go Further Women at Loblaw/ Sommet pour la Journée internationale des femmes de 2022 organisé par Voyez grand Femmes chez Loblaw</h1>
            // 	<p>We hope you enjoyed our virtual International Women’s Day summit! Watch any sessions you missed or rewatch your favourites by visiting the <a href="/gallery"><strong>Gallery room</strong></a> and clicking on the <strong>VOD sign</strong></p>
            // 	<p>Nous espérons que vous avez apprécié notre sommet virtuel de la Journée internationale de la femme! Visitez la <a href="/gallery"><strong>salle de galerie</strong></a> et cliquez sur l’affiche de <strong>vidéos sur demande (VSD).</strong></p>
            // </DisplayOnce>,
        },
        {
            background: "https://assets.swoogo.com/uploads/full/1649731-6230e2a0a84bb.jpg",
            // extras: <DisplayOnce
            // 	id="gallery-postevent"
            // 	// This should be in the event CSS tbh but I couldn't be arsed
            // 	style={{
            // 		padding: "3rem",
            // 		background: "#862c91",
            // 		borderRadius: "1rem",
            // 		color: "white",
            // 		maxWidth: "60rem",
            // 	}}
            // 	dismissHTML="X"
            // >
            // 	<h1>Welcome to the Gallery! / Bienvenue dans la galerie</h1>
            // 	<p>The Gallery features a collection of content curated for #IWD2022. Simply click on each exhibit item to view the content.</p>
            // 	<p><strong>Click on the VOD / VSD arrow to access all recordings of our sessions.</strong></p>
            // 	<p>La galerie présente une collection de contenu préparé pour la #JIDF2022. Il suffit de cliquer sur chaque élément de l’exposition pour en voir le contenu.</p>
            // 	<p><strong>Cliquez sur la flèche VOD/VSD pour accéder à tous les enregistrements de nos séances.</strong></p>
            // </DisplayOnce>,
            name: "gallery",
            links: [
                {
                    width: "6.4%",
                    height: "5.7%",
                    left: "94%",
                    top: "0.5%",
                    label: "Exit to Lobby",
                    href: "/lobby",
                    isExternal: false,
                },
                {
                    width: "8.4%",
                    height: "17.7%",
                    left: "23.8%",
                    top: "73.5%",
                    label: "Books by women public figures",
                    target: "_blank",
                    href: `https://assets.swoogo.com/uploads/1634478-6226858e07b60.pdf`,
                    isExternal: true,
                },
                {
                    width: "8.4%",
                    height: "17.7%",
                    left: "40.5%",
                    top: "73.5%",
                    label: "Books by women business leaders",
                    target: "_blank",
                    href: `https://assets.swoogo.com/uploads/1634477-6226858b1bd76.pdf`,
                    isExternal: true,
                },
                {
                    width: "8.4%",
                    height: "17.7%",
                    left: "57.2%",
                    top: "73.5%",
                    label: "Thought provoking books",
                    target: "_blank",
                    href: `https://assets.swoogo.com/uploads/1634479-6226859514198.pdf`,
                    isExternal: true,
                },
                {
                    width: "22.2%",
                    height: "24.5%",
                    left: "25.8%",
                    top: "15.5%",
                    label: "Recovering from the She-cession",
                    onClick: () => { document.getElementById("she-session").click() },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "22.2%",
                    height: "24.5%",
                    left: "51.8%",
                    top: "15.5%",
                    label: "2021 WXN Mentoring Program Wrap Up",
                    onClick: () => {
                        document.getElementById("mentoring").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "22.2%",
                    height: "24.5%",
                    left: "25.8%",
                    top: "41.5%",
                    label: "Meet The 37-Year-Old CEO Who Turned Vimeo Into a Billion-Dollar Company",
                    onClick: () => { document.getElementById("ceo").click() },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "22.2%",
                    height: "24.5%",
                    left: "51.8%",
                    top: "41.5%",
                    label: "Creating New Norms",
                    onClick: () => { document.getElementById("wxn-fireside").click() },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "11.2%",
                    height: "38.5%",
                    left: "74.8%",
                    top: "55.5%",
                    label: "VOD",
                    href: "/vod-am",
                    isExternal: true,
                },
            ]
        },
        {
            background: "https://assets.swoogo.com/uploads/full/1639392-622903562f5a1.jpg",
            name: "vod-am",
            links: [
                {
                    width: "6.4%",
                    height: "5.7%",
                    left: "1.1%",
                    top: "0.5%",
                    label: "Exit to Gallery",
                    href: "/gallery",
                    isExternal: true,
                },
                {
                    width: "6.4%",
                    height: "5.7%",
                    left: "94%",
                    top: "0.5%",
                    label: "Exit to Gallery",
                    href: "/gallery",
                    isExternal: false,
                },
                {
                    width: "30.9%",
                    height: "17.2%",
                    left: "18.3%",
                    top: "12.8%",
                    label: "International Women’s Day Opening Remarks",
                    onClick: () => {
                        document.getElementById("opening-remarks").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "30.9%",
                    height: "17.2%",
                    left: "18.3%",
                    top: "32.8%",
                    label: "Go Further Women Event Welcome Session",
                    onClick: () => {
                        document.getElementById("welcome-session").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "30.9%",
                    height: "17.2%",
                    left: "18.3%",
                    top: "52.2%",
                    label: "Fireside Chat with Mary MacIsaac & Galen Weston",
                    onClick: () => {
                        document.getElementById("fireside").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "30.9%",
                    height: "17.2%",
                    left: "18.3%",
                    top: "71.8%",
                    label: "Transcending Gender: Overcoming Internalized Gender Stereotypes",
                    onClick: () => {
                        document.getElementById("transcending-gender").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "32.8%",
                    height: "17.6%",
                    left: "50.1%",
                    top: "12.7%",
                    label: "Founders Circle with Sasha Exeter, Nudestix and The Unscented Company",
                    onClick: () => {
                        document.getElementById("founders-circle").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "32.8%",
                    height: "17.6%",
                    left: "50.1%",
                    top: "32.9%",
                    label: "Tackling Bias Through Allyship and Mentorship",
                    onClick: () => {
                        document.getElementById("allyship-mentorship").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "32.8%",
                    height: "17.6%",
                    left: "50.1%",
                    top: "52.3%",
                    label: "Leveraging the power of informal networks",
                    onClick: () => {
                        document.getElementById("informal-networks").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "32.8%",
                    height: "17.6%",
                    left: "50.1%",
                    top: "72.3%",
                    label: "The Importance of Active Allyship",
                    onClick: () => {
                        document.getElementById("allyship").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "28.3%",
                    height: "7%",
                    left: "35.7%",
                    top: "91%",
                    label: "",
                    isExternal: true,
                    href: "/vod-pm"
                },
            ]
        },
        {
            background: "https://assets.swoogo.com/uploads/full/1639393-62290358ca136.jpg",
            name: "vod-pm",
            links: [
                {
                    width: "6.4%",
                    height: "5.7%",
                    left: "1.1%",
                    top: "0.5%",
                    label: "Exit to Gallery",
                    href: "/gallery",
                    isExternal: true,
                },
                {
                    width: "6.4%",
                    height: "5.7%",
                    left: "94%",
                    top: "0.5%",
                    label: "Exit to Gallery",
                    href: "/gallery",
                    isExternal: true,
                },
                {
                    width: "29.3%",
                    height: "17.6%",
                    left: "3.5%",
                    top: "13.0%",
                    label: "Exploring Inclusion of Transgender and Queer Identities",
                    onClick: () => {
                        document.getElementById("trans").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.1%",
                    height: "17.6%",
                    left: "33.6%",
                    top: "13.1%",
                    label: "Breaking the Bias in Health and Beauty",
                    onClick: () => {
                        document.getElementById("beauty").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.2%",
                    height: "14.2%",
                    left: "65.4%",
                    top: "13.0%",
                    label: "#BreakTheBias- Perspectives from Women in Operations",
                    onClick: () => {
                        document.getElementById("operations").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "29.4%",
                    height: "17.8%",
                    left: "3.5%",
                    top: "32.7%",
                    label: "Real Talk with BEEP: Breaking the Bias",
                    onClick: () => {
                        document.getElementById("beep").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.1%",
                    height: "17.5%",
                    left: "33.6%",
                    top: "32.9%",
                    label: "Breaking the Bias & Building your Brand in the Discount Division",
                    onClick: () => {
                        document.getElementById("discount").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.1%",
                    height: "14.0%",
                    left: "65.6%",
                    top: "28.8%",
                    label: "Parenting Beyond the Pandemic",
                    onClick: () => {
                        document.getElementById("parenting").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "29.3%",
                    height: "17.8%",
                    left: "3.5%",
                    top: "52.6%",
                    label: "Unpacking the Impacts of COVID-19 on Women’s Mental Health",
                    onClick: () => {
                        document.getElementById("covid").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.2%",
                    height: "17.6%",
                    left: "33.6%",
                    top: "52.2%",
                    label: "Battling Cultural Bias",
                    onClick: () => {
                        document.getElementById("battling-cultural-bias").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.1%",
                    height: "14%",
                    left: "65.5%",
                    top: "44.6%",
                    label: "Neurodiversity: Breaking the Bias",
                    onClick: () => {
                        document.getElementById("neurodiversity").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "29.3%",
                    height: "17.5%",
                    left: "3.5%",
                    top: "72.5%",
                    label: "Breaking the Bias in the Market Division",
                    onClick: () => {
                        document.getElementById("market-division").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.1%",
                    height: "17.5%",
                    left: "33.6%",
                    top: "72.9%",
                    label: "Bias Breakers: Women in Technology Spotlight",
                    onClick: () => {
                        document.getElementById("spotlight").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.1%",
                    height: "14.2%",
                    left: "65.5%",
                    top: "60.2%",
                    label: "Trailblazers in Cannabis",
                    onClick: () => {
                        document.getElementById("weed").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.1%",
                    height: "14.2%",
                    left: "65.4%",
                    top: "75.5%",
                    label: "Break the Bias in your Career Development and Closing Remarks",
                    onClick: () => {
                        document.getElementById("closing").click()
                    },
                    isExternal: false,
                    href: ""
                },
                {
                    width: "31.1%",
                    height: "6.8%",
                    left: "33.6%",
                    top: "91.5%",
                    label: "Morning Sessions",
                    href: "/vod-am",
                    isExternal: false,
                },
            ],
        },
        ...sessions,
        ...networkRoutes
    ]

    return <>
        <Navbar />
        <Router history={createHashHistory()} onChange={() => handleNewRoute(62791, "fake user ID")}>
            {links.map(Room)}
        </Router>
        {popups.map(ElfsightPopup)}
        <ClueModal id="2021 WXN Mentoring Program Wrap Up" triggerId="2021 WXN Mentoring Program Wrap Up" clueEng="break" clueFra="briser" />*/
        <TriviaModal ref={triviaRef} />
        <div id="modals"></div>
        <script src="https://apps.elfsight.com/p/platform.js" defer />
    </>

}
